import styled from 'styled-components';

export const CustomIcon = styled.img<any>``;
